module.exports = __webpack_public_path__ + "static/media/ilustracion2.6ab6ac1c.png";